export const QA_NAME_REFRESH_SUMMARY_BUTTON = 'refreshSummary'
